function ApiTitle() {
  return (
    <>
      <center>
        <br />
        <h1 className="card-title">TARO OAI-PMH API</h1>
      </center>
      <p className="card-body my-0 lead text-center">
        This endpoint is for metadata harvesting in OAI-PMH (Open Archives
        Initiative Protocol for Metadata Harvesting) format. This is separate
        from the Search API used by this site. Results are returned in XML.
      </p>
    </>
  );
}

export default ApiTitle;
